module.exports = __webpack_public_path__ + "img/samsung-galaxy-a30.64741aa1.jpg";